export const en = {
  header: {
    logo: 'Inbal Art Makers',
    nav: {
      tutorials: 'Tutorials',
      workshops: 'Workshops',
      shop: 'Shop',
      myOrders: 'My Orders',
      deals: 'Amazon Deals',
      about: 'About',
      contact: 'Contact',
      admin: 'Admin',
      cricut: 'Cricut',
      goldsmith: 'Goldsmith',
      teva: 'Sustainable Art',
      modeling3d: '3D Modeling',
      svgfiles: 'SVG Files',
      sublimation: 'Sublimation',
      others: 'Others',
      chat: 'Chat AI',
      freeTools: 'Free Tools'
    },
    search: 'Search',
    searchPlaceholder: 'Search tutorials, products, workshops...',
    cart: 'Shopping Cart',
    language: 'Change Language',
    login: 'Login',
    logout: 'Logout'
  },
  footer: {
    about: 'About Us',
    contact: 'Contact',
    terms: 'Terms of Use',
    copyright: 'Inbal Art Makers. All rights reserved.'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    phoneNumberOptional: 'Optional',
    noAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    loginFailed: 'Login failed',
    registrationFailed: 'Registration failed',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters long',
    forgotPassword: 'Forgot Password?',
    forgotPasswordDescription: 'Enter your email address and we will send you a link to reset your password.',
    sendResetLink: 'Send Reset Link',
    checkEmail: 'Check your email for the reset link.',
    sendAnother: 'Send Another Email',
    backToLogin: 'Back to Login',
    resetPassword: 'Reset Password',
    resetPasswordDescription: 'Enter your new password below.',
    newPassword: 'New Password',
    invalidToken: 'Invalid Token',
    invalidTokenMessage: 'This password reset link is invalid or has expired.',
    requestNewLink: 'Request New Link',
    marketingConsent: 'I agree to receive marketing messages, discount events and promotional offers from the site',
    marketingConsentOptional: 'Optional - You can uncheck at any time',
    emailVerification: 'Email Verification',
    emailVerificationDescription: 'Please enter the 5-digit verification code sent to your email address.',
    verificationCode: 'Verification Code',
    sendVerificationCode: 'Send Verification Code',
    verifyEmail: 'Verify Email',
    resendCode: 'Resend Code',
    codeExpired: 'Verification code has expired. Please request a new one.',
    invalidCode: 'Invalid verification code. Please try again.',
    emailVerified: 'Email verified successfully!',
    checkEmailForCode: 'Please check your email for the verification code.',
    backToRegistration: 'Back to Registration',
    userAlreadyExists: 'A user with this email already exists. Please try logging in instead.'
  },
    profile: {
      editProfile: 'Edit Profile',
      profileInformation: 'Profile Information',
      changePassword: 'Change Password',
      updateProfile: 'Update Profile',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      profileUpdated: 'Profile updated successfully',
      passwordChanged: 'Password changed successfully',
      updateFailed: 'Failed to update profile',
      passwordChangeFailed: 'Failed to change password',
      cannotChange: 'Cannot be changed',
      clickToChangePassword: 'Click to change your password',
      deleteAccount: 'Delete Account',
      deleteAccountWarning: 'This action is irreversible and will permanently delete your account and all previous purchases.',
      deleteAccountConfirm: 'Are you sure you want to delete your account?',
      accountDeleted: 'Account deleted successfully',
      deleteAccountFailed: 'Failed to delete account'
    },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    home: 'Home'
  },
  myOrders: {
    title: 'My Orders',
    subtitle: 'View and manage all your past purchases',
    notAuthenticated: 'Please log in to view your orders',
    loading: 'Loading your orders...',
    empty: {
      title: 'No Orders Yet',
      description: 'You haven\'t made any purchases yet. Discover our amazing collection of tutorials, workshops, and digital products - your creative journey starts here!'
    },
    table: {
      orderDate: 'Order Date',
      productType: 'Product Type',
      name: 'Product Name',
      amount: 'Amount',
      image: 'Image',
      action: 'Action'
    },
    productTypes: {
      tutorial: 'Tutorial',
      workshop: 'Workshop',
      item: 'Item',
      file: 'File'
    },
    actions: {
      download: 'Download',
      open: 'Open'
    },
    unknownProduct: 'Unknown Product'
  },
  admin: {
    tabs: {
      users: 'Users Management',
      workshops: 'Workshops Management',
      shop: 'Shop Management',
      tutorials: 'Tutorials Management',
      files: 'Files Management',
      bannerTexts: 'Banner Texts',
      sendGift: 'Send Gift',
      orders: 'Orders Management',
      checkoutSessions: 'Checkout Sessions',
      purchaseStats: 'Purchase Statistics'
    },
    sorting: {
      sortBy: 'Sort By',
      order: 'Order',
      ascending: 'Ascending',
      descending: 'Descending',
      joinedDate: 'Joined Date',
      lastLogin: 'Last Login',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      never: 'Never'
    },
    products: {
      addNew: 'Add New Product',
      edit: 'Edit Product',
      confirmDelete: 'Are you sure you want to delete this product?',
      title: 'Title',
      description: 'Description',
      category: 'Category',
      price: 'Price',
      discount: 'Discount (%)',
      inventory: 'Inventory',
      promoted: 'Promoted',
      active: 'Active',
      actions: 'Actions',
      priority: 'Priority',
      customizable: 'Customizable',
      dragAndDropImage: 'Drag and drop main image here',
      orClickToUploadImage: 'or click to upload',
      selectedImage: 'Selected main image',
      dragAndDropSecondaryImages: 'Drag and drop secondary images here',
      orClickToUploadSecondaryImages: 'or click to upload',
      selectedSecondaryImages: 'Selected secondary images',
      atLeastOneImageRequired: 'At least one image is required',
      uploadFailed: 'Upload failed. Please try again.',
      categories: {
        cricut: 'Cricut',
        goldsmith: 'Goldsmith',
        teva: 'Sustainable Art',
        modeling3d: '3D Modeling',
        svgfiles: 'SVG Files',
        sublimation: 'Sublimation',
        others: 'Others'
      }
    },
    workshops: {
      addNew: 'Add New Workshop',
      edit: 'Edit Workshop',
      confirmDelete: 'Are you sure you want to delete this workshop?',
      title: 'Title',
      description: 'Description',
      location: 'Location',
      category: 'Category',
      level: 'Level',
      price: 'Price',
      participants: 'Participants',
      actions: 'Actions',
      participantLimit: 'Participant Limit',
      earlyBirdDate: 'Early Bird Date',
      earlyBirdDiscount: 'Early Bird Discount (%)',
      image: 'Image URL',
      workshopDates: 'Workshop Dates',
      date: 'Date',
      duration: 'Duration (minutes)',
      addDate: 'Add Another Date',
      dragAndDrop: 'Drag and drop an image here',
      orClickToUpload: 'or click to browse',
      selectedImage: 'Selected Image URL',
      active: 'Active',
      priority: 'Priority',
      levels: {
        title: 'Levels',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        all: 'All Levels'
      },
      categories: {
        cricut: 'Cricut',
        goldsmith: 'Goldsmith',
        teva: 'Sustainable Art',
        modeling3d: '3D Modeling',
        svgfiles: 'SVG Files',
        sublimation: 'Sublimation',
        others: 'Others'
      }
    },
    tutorials: {
      addNew: 'Add New Tutorial',
      edit: 'Edit Tutorial',
      confirmDelete: 'Are you sure you want to delete this tutorial?',
      title: 'Title',
      description: 'Description',
      category: 'Category',
      level: 'Level',
      price: 'Price',
      discount: 'Discount (%)',
      actions: 'Actions',
      active: 'Active',
      priority: 'Priority',
      dragAndDropImage: 'Drag and drop an image here',
      orClickToUploadImage: 'or click to browse',
      selectedImage: 'Selected Image URL',
      dragAndDropContentImages: 'Drag and drop content images here',
      orClickToUploadContentImages: 'or click to browse',
      selectedContentImages: 'Selected Content Images',
      atLeastOneImageRequired: 'At least one content image is required',
      uploadFailed: 'Upload failed. Please try again.',
      levels: {
        title: 'Levels',
        beginner: 'Beginner',
        medium: 'Medium',
        advanced: 'Advanced'
      },
      categories: {
        cricut: 'Cricut',
        goldsmith: 'Goldsmith',
        teva: 'Sustainable Art',
        modeling3d: '3D Modeling',
        svgfiles: 'SVG Files',
        sublimation: 'Sublimation',
        others: 'Others'
      }
    },
    bannerTexts: {
      title: 'Banner Texts Management',
      addNew: 'Add New Banner Text',
      edit: 'Edit Banner Text',
      text: 'Text',
      endDate: 'End Date',
      actions: 'Actions',
      noEndDate: 'No End Date',
      confirmDelete: 'Are you sure you want to delete this banner text?',
      errors: {
        textRequired: 'Text is required'
      }
    },
    sendGift: {
      title: 'Send Gift',
      selectUser: 'Select User',
      userSearchPlaceholder: 'Search by name or email...',
      typeToSearch: 'Type at least 2 characters to search',
      noUsersFound: 'No users found',
      selectType: 'Product Type',
      typeTutorial: 'Tutorial',
      typeFile: 'SVG File',
      selectItem: 'Select Item',
      sendButton: 'Send Gift',
      sending: 'Sending...',
      success: 'Gift sent successfully!',
      errors: {
        missingFields: 'Please select a user and an item',
        userSearchFailed: 'Failed to search users',
        itemsFetchFailed: 'Failed to fetch items',
        sendFailed: 'Failed to send gift'
      }
    },
    orders: {
      orderId: 'Order ID',
      customer: 'Customer',
      product: 'Product',
      productType: 'Type',
      amount: 'Amount',
      status: 'Status',
      date: 'Date',
      paymentId: 'Payment ID',
      actions: 'Actions',
      noOrders: 'No orders found',
      loading: 'Loading orders...',
      error: 'Error loading orders',
      completed: 'Completed',
      preparing: 'In Preparation',
      refunded: 'Refunded',
      cancelled: 'Cancelled',
      updateStatus: 'Update Status',
      viewAddress: 'View shipping address',
      markCompleted: 'Mark as completed',
      shippingAddress: 'Shipping Address',
      flat: 'Apt',
      phone: 'Phone',
      markCompletedSuccess: 'Order marked as completed',
      markCompletedError: 'Failed to update order status',
      selectStatus: 'Select Status',
      sortBy: 'Sort By',
      sortByTime: 'Time',
      sortByAmount: 'Amount',
      sortByStatus: 'Status',
      sortOrder: 'Sort Order',
      ascending: 'Ascending',
      descending: 'Descending',
      deletedUser: 'User Deleted'
    },
    checkoutSessions: {
      sessionId: 'Session ID',
      customer: 'Customer',
      items: 'Items',
      totalPrice: 'Total Price',
      itemCount: 'Item Count',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      transactionId: 'Transaction ID',
      actions: 'Actions',
      noSessions: 'No checkout sessions found',
      loading: 'Loading checkout sessions...',
      error: 'Error loading checkout sessions',
      sortBy: 'Sort By',
      sortByCreatedAt: 'Created Date',
      sortByUpdatedAt: 'Updated Date',
      sortByTotalPrice: 'Total Price',
      sortByItemCount: 'Item Count',
      sortOrder: 'Sort Order',
      ascending: 'Ascending',
      descending: 'Descending',
      minItems: 'Minimum Items',
      viewDetails: 'View Details',
      productType: 'Type',
      deletedUser: 'User Deleted',
      quantity: 'Quantity',
      price: 'Price',
      shippingAddress: 'Shipping address',
      flat: 'Apt.',
      phone: 'Phone'
    },
    purchaseStats: {
      product: 'Product',
      productType: 'Type',
      totalPurchases: 'Total Purchases',
      totalRevenue: 'Total Revenue',
      averagePrice: 'Average Price',
      lastPurchase: 'Last Purchase',
      averageOrderValue: 'Average Order Value',
      uniqueProducts: 'Unique Products',
      startDate: 'Start Date',
      endDate: 'End Date',
      loading: 'Loading purchase statistics...',
      error: 'Error loading purchase statistics',
      sortBy: 'Sort By',
      sortByPurchases: 'Total Purchases',
      sortByRevenue: 'Total Revenue',
      sortByAveragePrice: 'Average Price',
      sortByLastPurchase: 'Last Purchase Date',
      sortByTitle: 'Product Title',
      sortOrder: 'Sort Order',
      ascending: 'Ascending',
      descending: 'Descending'
    }
  },
  passover: {
    newDesigns: '🎉 New designs for Passover, sign up now to get 10% off your first purchase'
  },
  pages: {
    about: {
      title: 'About Me - Cricut Workshops & Digital Design ',
      subtitle: 'Digital Designer & Art Educator - Cricut Expert ',
      description: 'I blend traditional craftsmanship with modern design, creating unique pieces that tell stories. My work focuses on sustainable materials and innovative techniques, specializing in Cricut workshops and digital design .',
      name: 'Inbal Levin',
      mission: 'I am Inbal Levin, a passionate artisan, jeweler, and creator, blending the timeless beauty of traditional craftsmanship with the innovative potential of modern digital design. As a Cricut expert , my work spans both the world of handcrafted creations and the cutting-edge realm of digital design, where I am proficient in both 2D and 3D design, as well as 3D printing. This unique combination allows me to live within both the world of artisanal traditions and the rapidly evolving future of technology, where everything is meticulously planned on a computer before coming to life in the real world.',
      vision: 'In addition to my personal artistic endeavors, I am also dedicated to sharing my knowledge and skills with others. I lead professional Cricut workshops focused on developing creative thinking, nurturing both children and adults to explore their imaginations and grow their artistic talents. These workshops include a variety of topics such as jewelry making, macramé, and urban nature crafts, offering participants the opportunity to connect with their creativity in meaningful ways.',
      values: 'Whether through hands-on experiences or cutting-edge digital design, I strive to inspire and empower individuals to express themselves through art and craft, bridging the gap between tradition and the future. As a Cricut expert , I bring my knowledge and experience to every workshop and tutorial.',
      team: {
        title: 'Our Team',
        member1: {
          name: 'Team Member 1',
          role: 'Role 1',
          bio: 'Bio 1'
        },
        member2: {
          name: 'Team Member 2',
          role: 'Role 2',
          bio: 'Bio 2'
        },
        member3: {
          name: 'Team Member 3',
          role: 'Role 3',
          bio: 'Bio 3'
        }
      },
      contact: {
        title: 'Contact Us',
        description: 'Get in touch with us for any questions or inquiries.',
        email: 'Email'
      }
    },
    contact: {
      title: "Get in Touch",
      subtitle: "I'd love to hear from you! Whether you have a question about my work, want to inquire about a workshop, or simply want to chat about creativity, feel free to reach out. I'm always excited to connect and share ideas.\n\nPlease use the form below or get in touch via email or social media, and I'll respond as soon as I can. Looking forward to hearing from you!",
      email: "Email Me",
      form: {
        name: "Your Name",
        email: "Your Email",
        subject: "Subject",
        message: "Your Message",
        submit: "Send Message",
        successMessage: "Thank you for your message! I'll get back to you soon.",
        errorMessage: "Oops! Something went wrong. Please try again."
      },
      info: {
        title: "Contact Information",
        addressTitle: "Address",
        address: "Yigal Alon St, Herzliya, Israel",
        phoneTitle: "Phone",
        phone: "054-7798844",
        emailTitle: "Email",
        email: "inbal.artmakers@gmail.com"
      }
    },
    workshops: {
      title: 'Cricut Workshops & Digital Design Classes ',
      subtitle: 'Join our professional Cricut workshops  and unleash your artistic potential',
      loading: 'Loading workshops...',
      error: 'Error loading workshops',
      register: 'Register Now',
      dates: 'Dates',
      minutes: 'minutes',
      levels: {
        title: 'Levels',
        beginner: 'Beginner',
        medium: 'Medium',
        advanced: 'Advanced',
      },
      categories: {
        title: 'Categories',
        painting: 'Painting',
        drawing: 'Drawing',
        sculpture: 'Sculpture',
        digital: 'Digital Art',
        mixed: 'Mixed Media',
        photography: 'Photography',
        printmaking: 'Printmaking',
        ceramics: 'Ceramics',
        textiles: 'Textiles',
        jewelry: 'Jewelry Making',
        cricut: 'Cricut',
        goldsmith: 'Goldsmith',
        teva: 'Sustainable Art',
        modeling3d: '3D Modeling',
        svgfiles: 'SVG Files',
        sublimation: 'Sublimation',
        others: 'Others',
        other: 'Other'
      }
    },
    tutorials: {
      title: 'Tutorials',
      subtitle: 'Learn how to create beautiful jewelry',
      loading: 'Loading tutorials...',
      viewDetails: 'View Details',
      openTutorial: 'Open Tutorial',
      addToCheckout: 'Add to Checkout',
      addedToCheckout: 'Tutorial added to checkout successfully',
      errorLoading: 'Error loading tutorial',
      notFound: 'Tutorial not found',
      openInNewTab: 'Open Tutorial in New Tab',
      openInNewTabDescription: 'This tutorial will open in a new tab for the best viewing experience.',
      filters: {
        sortBy: 'Sort By',
        difficulty: 'Difficulty',
        duration: 'Duration'
      },
      categories: {
        all: 'All Levels',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced'
      },
      available: 'Available',
      page: 'Page',
      of: 'of'
    },
    shop: {
      title: 'Shop',
      subtitle: 'Discover our unique products',
      filters: {
        category: 'Category',
        sortBy: 'Sort By'
      },
      categories: {
        all: 'All Categories'
      },
      sort: {
        newest: 'Newest',
        priceLow: 'Price: Low to High',
        priceHigh: 'Price: High to Low'
      },
      addToCart: 'Add to Cart'
    },
    category: {
      products: 'Products',
      workshops: 'Workshops',
      tutorials: 'Tutorials',
      inCart: 'In Cart',
      removeFromCart: 'Remove from Cart',
      downloadFile: 'Download File',
      productsDescription: 'Explore our collection of high-quality products',
      workshopsDescription: 'Join our interactive workshops and learn new skills',
      tutorialsDescription: 'Access our comprehensive video tutorials',
      cricut: {
        description: `Discover the magic of digital cutting.
Digital cutting machines have revolutionized home crafting with paper.
With simple tools, anyone can design digitally and transfer products for cutting with comfort and ease.
As a graphic designer with extensive experience and many successful students working in the field, I bring the world of graphic design and branding to you, even for students with no graphic experience at all.
I teach private and group lessons in my Herzliya studio, helping you master cutting with the machine and tailoring the learning to your business needs.
With a degree in Business Administration and experience in guiding new businesses, beyond technical and design knowledge, I'm happy to provide consulting for creative businesses to help them stand out and advance.
As part of the Cricut brand ambassador team , I'm delighted to provide you with a complete package for purchase, learning, and success, whether as a hobby or profession.
Join me for a magical jewelry-making session - to imagine and create. Together we'll get inspired, plan, learn about possible creation processes, and create a personal handmade piece of jewelry.`
      },
      goldsmith: {
        description: `Discover the art of goldsmithing and jewelry making.
Learn traditional techniques combined with modern tools and methods.
From basic metalworking to advanced stone setting, our courses cover all aspects of jewelry creation.
Perfect for both beginners and experienced craftsmen looking to enhance their skills.
Join our workshops to create unique pieces under expert guidance.
All necessary tools and materials are provided during the sessions.
Start your journey in the fascinating world of jewelry making today.`
      },
      others: {
        description: 'Browse our diverse collection of crafting supplies and tools'
      },
      teva: {
        description: 'Discover the art of sustainable art'
      },
      modeling3d: {
        description: 'Discover the art of 3D modeling'
      },
      svgfiles: {
        description: 'Discover the art of SVG files'
      },
      sublimation: {
        description: 'Discover the art of sublimation'
      }
    },
    chat: {
      title: 'Cricut Chat AI',
      description: 'Get instant help with your Cricut questions from our AI assistant. Chat history is stored only in your browser and cleared when you close the tab.',
      welcome: 'Welcome to Cricut Chat AI!',
      welcomeSubtitle: 'Ask me anything about Cricut machines, Design Space, materials, or project ideas.',
      placeholder: 'Type your question here...',
      clear: 'Clear Chat',
      error: 'Failed to send message. Please try again.'
    },
    freeTools: {
      title: 'Free Tools',
      description: 'Access free tools to help with your Cricut projects. All tools run 100% in your browser - no data is sent to our servers.',
      tabs: {
        imageToSVG: 'Image to SVG',
        promptToImage: 'Prompt to Image (Cricut)',
        promptToImageUnfiltered: 'Prompt to Image (Full)'
      },
      imageToSVG: {
        title: 'Image to SVG Converter',
        description: 'Convert images to SVG outlines for use in Cricut Design Space. Upload an image, adjust the threshold and sharpness, and download the SVG file.\nImportant: Your image is not stored anywhere and all the magic happens in your browser.',
        uploadImage: 'Upload Image',
        processing: 'Processing...',
        original: 'Original Image',
        processed: 'Processed Image',
        threshold: 'Threshold (Black/White)',
        sharpness: 'Sharpness (Outline Ratio)',
        svgOutput: 'SVG Output',
        download: 'Download SVG',
        downloadSvg: 'Download SVG',
        downloadPng: 'Download PNG',
        errors: {
          invalidFile: 'Please upload a valid image file.',
          loadFailed: 'Failed to load image.',
          readFailed: 'Failed to read file.',
          canvasContext: 'Failed to initialize canvas.',
          processingFailed: 'Failed to process image. Please try again.',
          loginRequired: 'Please log in to use this tool. Redirecting to login page...'
        }
      },
      promptToImage: {
        title: 'Create Cricut Cutting File',
        description: 'Create Cricut-ready cutting files from text descriptions. Write a short description in Hebrew of the object you want to cut, and our AI will create a black and white outline file perfect for cutting with your Cricut machine.',
        promptPlaceholder: 'Enter a description in Hebrew (e.g., "כלב", "פרח", "לב")',
        negativePromptPlaceholder: 'Negative prompt (optional) - things to avoid in Hebrew',
        generateButton: 'Create Cutting File',
        generating: 'Creating cutting file...',
        downloadSvg: 'Download SVG',
        downloadPng: 'Download PNG',
        errors: {
          emptyPrompt: 'Please enter a description',
          loginRequired: 'Please log in to use this tool. Redirecting to login page...',
          generationFailed: 'Failed to create cutting file. Please try again.',
          downloadFailed: 'Failed to download cutting file. Please try again.'
        },
        success: 'Cutting file created successfully!'
      },
      promptToImageUnfiltered: {
        title: 'AI Image Generator (Full Prompt)',
        description: 'Generate images from text descriptions with full control. Write a description in Hebrew, and our AI will translate it to English and generate an image exactly as you described. All styling, colors, and details from your prompt will be preserved.',
        promptPlaceholder: 'Enter a description in Hebrew (e.g., "כלב חום יושב בפארק", "פרח אדום גדול")',
        negativePromptPlaceholder: 'Negative prompt (optional) - things to avoid in Hebrew',
        generateButton: 'Generate Image',
        generating: 'Generating...',
        downloadSvg: 'Download SVG',
        downloadPng: 'Download PNG',
        errors: {
          emptyPrompt: 'Please enter a description',
          loginRequired: 'Please log in to use this tool. Redirecting to login page...',
          generationFailed: 'Failed to generate image. Please try again.',
          downloadFailed: 'Failed to download image. Please try again.'
        },
        success: 'Image generated successfully!',
        styling: {
          title: 'Styling Options (Optional)',
          style: 'Style',
          effectColor: 'Effect - Color',
          effectLightning: 'Effect - Lightning',
          effectFraming: 'Effect - Framing',
          colors: 'Dominant Colors',
          colorWeight: 'Weight (0.05-1)',
          none: 'None'
        }
      }
    }
  },
  checkout: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty',
    emptySubtitle: 'Looks like you haven\'t added anything to your cart yet!',
    continueShopping: 'Continue Shopping',
    total: 'Total',
    clear: 'Clear Cart',
    proceed: 'Proceed to Checkout',
    processing: 'Processing...',
    currency: '₪',
    productType: {
      tutorial: 'Tutorial',
      workshop: 'Workshop',
      item: 'Product',
      file: 'Digital File'
    },
    type: 'Type',
    image: 'Image',
    productTitle: 'Product',
    price: 'Price',
    quantity: 'Quantity',
    actions: 'Actions',
    clearConfirmation: {
      title: 'Clear Cart',
      message: 'Are you sure you want to clear your cart? This action cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Clear Cart'
    },
    terms: {
      accept: 'I accept the ',
      view: 'Terms and Conditions'
    },
    shipping: {
      title: 'Shipping Address',
      subtitle: 'Required for physical products in your cart.',
      fullName: 'Recipient full name',
      city: 'City',
      street: 'Street',
      streetNumber: 'Street number',
      flat: 'Apartment / flat',
      notes: 'Address notes',
      phone: 'Phone number',
      required: 'This field is required',
      selectCityFirst: 'Select a city first',
      noStreets: 'No streets found',
      confirm: {
        title: 'Confirm shipping address',
        message: 'Please verify that your shipping details are correct before continuing to payment.',
        confirm: 'OK, continue',
        cancel: 'Cancel'
      }
    }
  },
  payment: {
    processing: {
      title: 'Processing Your Payment...',
      details: 'Please wait while we create your orders and process your payment. This may take a few moments.',
      creatingOrders: 'Creating your orders...',
      completed: 'Processing completed'
    },
    success: {
      title: 'Payment Successful!',
      message: 'Thank you for your purchase. Your payment has been processed successfully.',
      details: 'You will receive a confirmation email shortly with your purchase details.',
      continueShopping: 'Continue Shopping',
      viewOrders: 'View My Orders'
    },
    failure: {
      title: 'Payment Failed',
      message: 'Unfortunately, your payment could not be processed. This may be due to insufficient funds, an expired card, or a technical issue.',
      details: 'Please check your payment details and try again, or contact our support team if the problem persists.',
      tryAgain: 'Try Again',
      backToHome: 'Back to Home'
    }
  },
    homepage: {
    hero: {
      title: 'Professional Cricut Workshops  - Where Art Meets Innovation',
      subtitle: 'Discover the perfect blend of traditional craftsmanship and modern digital design with Cricut expert Inbal Levin ',
      cta: 'Start Your Creative Journey'
    },
    about: {
      subtitle: 'Jeweler, Artist, and Creator - Cricut Expert ',
      description: 'I am a jeweler, artist, and creator who works with both traditional crafts and digital design (2D and 3D). As a Cricut expert , I live in both worlds - the timeless world of handmade crafts and the future-oriented world where everything is planned on a computer and printed.',
      workshops: {
        title: 'Cricut Workshops & Digital Design',
        description: 'I conduct professional Cricut workshops for developing creative thinking and sustainability for children, as well as jewelry making, macramé, and urban nature crafts workshops for both children and adults. I teach how to work with digital cutting machines, branding, and develop independent creative thinking that doesn\'t rely only on ready-made projects.'
      }
    },
    featured: {
      title: 'Discover the Perfect Blend of Traditional Craftsmanship and Modern Design',
      subtitle: 'From digital design tutorials to hands-on workshops and more..',
      tutorials: {
        title: 'Digital Design Tutorials',
        description: 'Master the art of digital design with our comprehensive tutorials. Perfect for beginners and advanced creators alike.',
        cta: 'Browse Tutorials'
      },
      workshops: {
        title: 'Hands-on Workshops',
        description: 'Join our immersive workshops and bring your creative ideas to life. Learn from expert artisans in a supportive environment.',
        cta: 'View Workshops'
      },
      shop: {
        title: 'Unique Creations',
        description: 'Discover our collection of handcrafted jewelry and art pieces. Each item tells its own story.',
        cta: 'Shop Now'
      }
    },
    cta: {
      title: 'Ready to Unleash Your Creativity?',
      description: 'Join our community of makers and start your creative journey today. Whether you\'re a beginner or an experienced artist, we have something for everyone.',
      button: 'Get Started'
    },
    inspiring: {
      title: 'Let\'s Turn Ideas into Art',
      subtitle: 'Together, we bring your creative vision to life – with professional guidance, innovative tools, and personal support from sketch to perfect result.'
    }
  },
  search: {
    resultsFor: 'Search results for',
    resultsFound: 'results found',
    noResults: 'No results found',
    tryDifferentKeywords: 'Try different keywords or check your spelling',
    backToHome: 'Back to Home',
    types: {
      tutorial: 'Tutorial',
      file: 'SVG File',
      product: 'Product',
      workshop: 'Workshop'
    }
  },
  deals: {
    title: 'Amazon Deals',
    subtitle: 'Discover the tools and products I use in my craft',
    noDeals: 'No deals available at the moment. Check back soon!',
    loading: 'Loading deals...',
    viewOnAmazon: 'View on Amazon',
    price: 'Price',
    asOf: 'Price as of',
    disclosure: 'Disclosure',
    disclosureText: 'As an Amazon Associate, I earn from qualifying purchases. Product prices are snapshots taken at the time we discovered them and may change. When you click on a product link and make a purchase, I will receive a small commission at no additional cost to you.',
    priceNote: 'Product prices and availability are accurate as of the date/time indicated and are subject to change. Any price and availability information displayed on Amazon.com at the time of purchase will apply to the purchase of this product.',
    amazonNote: 'All product links on this page are Amazon Associate links.',
    importantNote: 'Some items are manually curated by me, while others are automatically discovered. Please verify the current price on Amazon and, most importantly, confirm that items are eligible for free shipping on orders over $49 USD before purchasing.'
  }
}; 